import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Ruler } from "lucide-react";

const ROWS = [
  ["S", "34–36", "26–28", "38"],
  ["M", "38–40", "30–32", "40"],
  ["L", "42–44", "34–36", "42"],
  ["XL", "46–48", "38–40", "44"],
  ["2XL", "50–52", "42–44", "46"],
];

export default function SizeGuide() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          data-testid="size-guide-btn"
          className="flex items-center gap-2 border border-white/25 rounded-full px-6 py-3 text-[10px] uppercase tracking-[0.22em] text-white/70 transition-colors duration-300 hover:bg-white hover:text-black"
        >
          <Ruler className="w-3.5 h-3.5" /> Size Guide
        </button>
      </DialogTrigger>
      <DialogContent data-testid="size-guide-dialog" className="glass-panel border-white/10 text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display font-medium uppercase tracking-[0.2em] text-sm">Size Guide</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-white/45 font-light mb-4">Measurements in inches. Sets run true to size with a relaxed streetwear fit — size up for oversized.</p>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] uppercase tracking-[0.2em] text-white/40 border-b border-white/10">
              <th className="text-left py-2 font-normal">Size</th>
              <th className="text-left py-2 font-normal">Chest</th>
              <th className="text-left py-2 font-normal">Waist</th>
              <th className="text-left py-2 font-normal">Jogger Inseam</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([s, chest, waist, inseam]) => (
              <tr key={s} className="border-b border-white/5">
                <td className="py-2.5 font-unbounded text-xs">{s}</td>
                <td className="py-2.5 text-white/60">{chest}</td>
                <td className="py-2.5 text-white/60">{waist}</td>
                <td className="py-2.5 text-white/60">{inseam}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
}
